'use client';

import * as React from 'react';
import Button from '@/components/ui/Button';
import Buttons from '@/components/ui/Buttons';
import useOfferOverlay from '@/lib/hooks/useOfferOverlay';

export interface IButtonActivatePackageProps {
  title: string;
}

const ButtonActivatePackage: React.FunctionComponent<IButtonActivatePackageProps> = (props) => {
  const { open: openOfferForm } = useOfferOverlay();
  return (
    <Buttons>
      <Button
        title={props.title}
        onClick={() => openOfferForm()}
        size={'medium'}
        iconLeft={'unlock'}
        theme={'primary'}
      />
    </Buttons>
  );
};

ButtonActivatePackage.displayName = 'ButtonActivatePackage';

export default ButtonActivatePackage;
